export { PortalCardProviderDeprecated, PortalCardProviderNew, getSmartCardUrl } from './smart-card-provider';
